const tutorScheduleListener = {
	async shift_state_changed() {
		await this.$store.dispatch("TutorSchedule/getCurrentShiftAndState");
	},
};


export default tutorScheduleListener;
